package b2d

object B2dParameters {
    const val CUSTOM_SCALE = 100.0

    const val NOTING_BIT = 0
    const val GROUND_BIT = 1
    const val PLAYER_BIT = 2
    const val FINISH_BIT = 4

    /**
     * fire bolt ability bit
     */
    const val FIRE_BOLT_BIT = 8
    const val FIRE_BOLT_SENSOR_BIT = 16

    /**
     * frost bolt ability bit
     */
    const val FROST_BOLD_BIT = 32

    /**
     * trap ability bit
     */
    const val TRAP_ABILITY_BIT = 64

    const val WATER_BIT = 128

    const val PLAYER_GROUND_SENSOR = 256

    const val WALL_LEFT_BIT = 512
    const val WALL_RIGHT_BIT = 1024

    const val TRAP_BIT = 2048
    const val COIN_BIT = 4096
}
